import type { Sprite } from "./sprite";
import type { SpriteAnimationFrame } from "./spriteAnimationFrame";

export class SpriteAnimation {
	loop: boolean;
	frames: SpriteAnimationFrame[];

	constructor(loop: boolean, frames: SpriteAnimationFrame[]) {
		this.loop = loop;
		this.frames = frames;
	}

	isSingleSprite(): boolean {
		return this.frames.length <= 1;
	}

	addFrame(sprite: Sprite, interval: number): void {
		this.frames.push({ sprite, interval });
	}
}
